import { ThemeProvider } from '@emotion/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { PrimeReactProvider } from 'primereact/api'
import React, { Suspense } from 'react'
import { Toaster } from 'react-hot-toast'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import 'chart.js/auto'
import { Errors } from '../Common/ErrorHandling/Errors'
import { theme } from '../Common/Theme'
import { store } from '../store'

import { AppRoutes } from './AppRoutes'
import Spinner from './Components/Spinner/Spinner'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import 'moment/locale/en-gb'

import './iconLibrary'

const Bootstrap = () => {
  const queryClient = new QueryClient()
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PrimeReactProvider>
          <LocalizationProvider
            dateAdapter={AdapterMoment}
            adapterLocale="en-gb">
            <ThemeProvider theme={theme}>
              <BrowserRouter>
                <Suspense fallback={<Spinner />}>
                  <div className="App">
                    <Toaster position="top-right" />
                    <Errors />
                    <AppRoutes />
                  </div>
                </Suspense>
              </BrowserRouter>
            </ThemeProvider>
          </LocalizationProvider>
        </PrimeReactProvider>
      </QueryClientProvider>
    </Provider>
  )
}

export default Bootstrap
